import React from 'react'
import { Grid, Text, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { useOrderFormShippingEstimate } from '../../../../hooks'

export type ShippingDeadlineSectionProps = {
  shippingEstimate: string
}

export const ShippingDeadlineSection = ({
  shippingEstimate,
}: ShippingDeadlineSectionProps) => {
  const { getEstimateMessage } = useOrderFormShippingEstimate()
  // [TODO]<checkout>: Add support for multiple products with differents shipping deadlines

  const estimateMessage = getEstimateMessage(shippingEstimate)

  return (
    <Grid rowGap="2rem" className={csx({ paddingTop: '$space-4' })}>
      <Text variant="title1" tone="secondary">
        <FormattedMessage id="checkout.order-summary.products-for-delivery.deadline-title" />
      </Text>
      <Text variant="title1">{estimateMessage}</Text>
    </Grid>
  )
}
